module.exports = __webpack_public_path__ + "img/web1.eb44431c.webp";